import { useLocation } from 'react-router-dom';

export interface PageContext {
  type: 'candidate' | 'job';
  id: number;
}

interface RouteMatcher {
  pattern: RegExp;
  type: PageContext['type'];
}

// Order matters only in that each pattern must fully match (via ^...$) so a
// sub-route like /jobs/45/funnel does NOT match the bare /jobs/:id pattern.
const ROUTE_MATCHERS: RouteMatcher[] = [
  { pattern: /^\/jobs\/(\d+)$/, type: 'job' },
  { pattern: /^\/people\/(\d+)$/, type: 'candidate' },
  { pattern: /^\/candidates\/(\d+)$/, type: 'candidate' },
];

export function derivePageContext(pathname: string): PageContext | null {
  for (const matcher of ROUTE_MATCHERS) {
    const match = pathname.match(matcher.pattern);
    if (match) {
      return { type: matcher.type, id: Number(match[1]) };
    }
  }
  return null;
}

export function usePageContext(): PageContext | null {
  const location = useLocation();
  return derivePageContext(location.pathname);
}
